/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promoflyerfineprint2Inputs */

const en_promoflyerfineprint2 = /** @type {(inputs: Promoflyerfineprint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan it with friends on Pulsify`)
};

const de_promoflyerfineprint2 = /** @type {(inputs: Promoflyerfineprint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Freunden planen auf Pulsify`)
};

/**
* | output |
* | --- |
* | "Plan it with friends on Pulsify" |
*
* @param {Promoflyerfineprint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const promoflyerfineprint2 = /** @type {((inputs?: Promoflyerfineprint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promoflyerfineprint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_promoflyerfineprint2(inputs)
	return de_promoflyerfineprint2(inputs)
});
export { promoflyerfineprint2 as "promoFlyerFineprint" }